/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from 'axios';
import auth from '../../../common/auth';
import common from '../common/index';

export default {
  // eslint-disable-next-line
  broadcastLogin({ commit }) {
    return axios({
      url: 'api/broadcastLogin',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  sendFriendInvitation({ commit }, payload) {
    return axios({
      url: 'api/sendFriendInvitation',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: payload,
    });
  },
  // eslint-disable-next-line
  sendNotificationReward({ commit }, payload) {
    return axios({
      url: `api/sendReward?id=${payload.reward}&notificationId=${payload.notif}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  updateDGamesForAddOn({ commit }, payload) {
    return axios({
      url: 'api/updateDGamesForAddOn',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: payload,
    }).catch((error) => {
      console.log(`Invoking updateDGamesForAddOn failed with the following error: ${error}`);
    });
  },
  updateDBonusAddOnGames({ commit }, payload) {
    return axios({
      url: 'api/updateDBonusAddOnGames',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: payload,
    }).then((response) => {
      const { responseEnum, data } = response.data;
      if (responseEnum === 'OPERATION_SUCCESS') {
        commit('game/setBonusAddOnGamePrize', data.name, { root: true });
      } else if (responseEnum === 'ALREADY_PLAYED') {
        commit('game/setBonusAddOnGameDataFromAchievements', "ALREADY_PLAYED", { root: true });
      }
    }).catch((error) => {
      console.log(`Invoking updateDBonusAddOnGames failed with the following error: ${error}`);
    });
  },
  changeVisibility({ commit }) {
    commit('common/toggleProfile', null, { root: true });
    return axios({
      url: `api/toggleProfileVisibility`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Reverting...Something went wrong while changing profile visibility: ${error}`);
      commit('common/toggleProfile', null, { root: true }); // revert on error
    });
  },
  getUserAchievements({ commit }) {
    return axios({
      url: `api/fetchUserAchievements`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const { responseEnum, data } = response.data;
      if (responseEnum === 'OPERATION_SUCCESS') {
        commit('setUserAchievements', data.achievementCategoryDTOs);
        commit('common/setTotalAchievements', { value: data.totalNumberOfAchievements }, { root: true });
      }
    }).catch((error) => {
      console.log(`Invoking getUserAchievements failed with the following error: ${error}`);
    });
  },
  getBonusPhases({ commit }) {
    return axios({
      url: `api/getBonusPhases`,
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const celebrity = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'PLAY_WITH_CELEB' && !bonus.dailyBonusType);
        const bundles = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'BUNDLES' && !bonus.dailyBonusType);
        const points = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'POINTS' && !bonus.dailyBonusType);
        const lantern = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'LIGHT_THE_LANTERNS' && !bonus.dailyBonusType);
        const puzzle = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'PUZZLE' && !bonus.dailyBonusType);
        const bonus = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type !== 'BUNDLES' && bonus.type !== 'POINTS' && bonus.type !== 'PLAY_WITH_CELEB' && bonus.dailyBonusType);
        commit('saveBonusDailyModal', ...bonus);
        commit('saveLanternGame', ...lantern);
        commit('savePuzzleGame', ...puzzle);
        commit('updateCelebrityInfo', ...celebrity);
        let bonusList = [...celebrity, ...bundles, ...points];
        if (common.state.showCrossPromotionPhase || common.state.showOptOutPhase) {
          bonusList = [...bonusList, {
            active: true,
            type: 'CROSS_PROMOTION',
          }];
        }
        commit('savePhaseBonusList', bonusList); // specific order
      }
    });
  },
  logoutUserFromAuthorizedPages({ commit }) {
    commit('clearAllData');
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('username');
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('username');
    commit('setjwtFromStorage', null);
    commit('setUserAuthorized', false);
    this.$router.push('/login');
  },
  // eslint-disable-next-line
  changeUsername({ commit }, payload) {
    return axios({
      url: `api/changeUsername?username=${payload.username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  registerEmail({ commit }, payload) {
    return axios({
      url: `api/registerEmail?email=${payload.email}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  validateEmail({ commit }, payload) {
    return axios({
      url: `api/validateEmail?checkId=${payload.verification.checkId}&email=${payload.verification.email}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('updateShowThankYouEmailModal', true);
        commit('setAlreadySubmittedUser', false);
      } else {
        commit('updateShowThankYouEmailModal', true);
        commit('setAlreadySubmittedUser', true);
      }
    });
  },
  sendReOptinPin({ commit }, payload) {
    // eslint-disable-next-line
    console.log('Verification Reoptin Pin Process' + payload.pinObject.pin);
    return axios({
      url: 'api/verifyReoptinPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        pin: payload.pinObject.pin,
        ti: payload.pinObject.ti,
        ts: payload.pinObject.ts,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', true);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else if (response.data.responseEnum === 'WRONG_PIN' || response.data.responseEnum === 'PIN_EXPIRED') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', true);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', true);
      }
    });
  },
  clearNotifications({ commit }) {
    return axios({
      url: 'api/clearNotifications',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const tempNotifications = [];
        commit({ type: 'storeNotifications', notifications: tempNotifications });
      }
    }).catch((error) => {
      console.log(`Invoking clearNotifications failed with the following error: ${error}`);
    });
  },
  changeNotificationReadStatus() {
    console.log('changeNotificationReadStatus process: ');
    return axios({
      url: 'api/changeNotificationReadStatus',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedRankDate() {
    return axios({
      url: 'api/getLastSharedRankDate',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedLevel() {
    return axios({
      url: 'api/getLastSharedLevel',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  giveContent({ commit }, payload) {
    console.log('giveContent process: ');
    return axios({
      url: 'api/giveContent',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        action: payload.action,
        userCurrentPoints: payload.points,
      },
    });
  },
  // eslint-disable-next-line
  subscribeUserForOnlineChannelAndThenOpenTheChannel({ commit, state }, payload) {
    console.log('Get subscribeUserForOnlineChannelAndThenOpenTheChannel');
    console.log(payload.statusOnline);
    console.log(state.isUserConnected);
    if ((!(state.isUserConnected && payload.statusOnline)) || (state.isUserConnected && !payload.statusOnline)) {
      commit('updateOnlineStatus', payload.statusOnline);
      return axios({
        url: 'api/onlineUserChannel',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          userStatusFromApp: payload.statusOnline,
        },
      });
    }
  },
  getUserNotifications({ commit }) {
    console.log('Get notifications');
    return axios({
      url: 'api/getStoredNotificationsV2',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      const notifications = response.data.data;
      commit({ type: 'storeNotifications', notifications });
      commit({ type: 'storeAchievementNotificationData', notifications: notifications.filter(not => not.notificationCategoryDTO.name === 'Achievement') });
    });
  },
  requestPin({ commit }, payload) {
    console.log('Get Pin Process');
    return axios({
      url: 'api/getPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
      },
    }).then((response) => {
      commit({ type: 'setRequestPinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      console.log(`Invoking requestPin failed with the following error: ${error}`);
    });
  },
  chargePinCall({ commit }, payload) {
    console.log("Invoking chargePinCall");
    return axios({
      url: 'api/charge',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
        pin: payload.value.pin,
      },
    }).then((response) => {
      commit({ type: 'setChargePinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      console.log(`Invoking chargePinCall failed with the following error: ${error}`);
    });
  },
  storedBundlesCall({ commit }) {
    return axios({
      url: 'api/getStoreItems',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit({ type: 'setBundles', value: response.data.data });
      }
    }).catch((error) => {
      console.log(`Invoking storedBundles failed with the following error: ${error}`);
    });
  },
  setMatchInfo({ commit }, payload) {
    commit({ type: 'setGameDetails', details: '' });
    commit({ type: 'setOppDetails', details: '' });
    return axios({
      url: 'api/getMatchHistory',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        duelId: payload.duelId,
      },
    }).then((response) => {
      const gameDetails = response.data.data;
      commit({ type: 'setGameDetails', details: gameDetails });
      const oppDetails = payload;
      commit({ type: 'setOppDetails', details: oppDetails });
    }).catch((error) => {
      console.log(`Invoking setMatchInfo failed with the following error: ${error}`);
    });
  },
  storeAvailableFreePlayPrize({ commit }, userLanguage) {
    return axios({
      url: `api/getFreePlayPrizeData?lang=${userLanguage}`,
      method: 'GET',
    }).then((response) => {
      // success callback
      // eslint-disable-next-line
      /* eslint-disable */
      console.log(response.data.data);
      const freePlayPrize = response.data.data;
      commit( 'setFreePlayPrize', freePlayPrize );
      /* eslint-enable */
    }).catch((error) => {
      console.log(`Invoking storeAvailableFreePlayPrize failed with the following error: ${error}`);
    });
  },
  storeAvailablePrizeTypes({ state, commit }, userLanguage) {
    return axios({
      url: `api/getPrizeData?lang=${userLanguage}`,
      method: 'GET',
    }).then((response) => {
      // success callback
      // eslint-disable-next-line
      const prizes = response.data.data;
      const types = [];
      /* eslint-disable */
      for (var i = 0; i < prizes.length; i++) {
        types.push(prizes[i].type);
      }
      const carouselPrizes = response.data.data;
      commit({ type: 'setCarouselPrizes', value: carouselPrizes });
      for (var i = 0; i < prizes.length; i++) {
        if (prizes[i].type === state.prizes.WEEKLY) {
          const weeklyPrize = prizes[i];
          commit({ type: 'setWeeklyPrize', value: weeklyPrize });
        } else if (prizes[i].type === state.prizes.DAILY) {
          const dailyPrize = prizes[i];
          commit({ type: 'setDailyPrize', value: dailyPrize });
        } else if (prizes[i].type === state.prizes.MONTHLY) {
          const monthlyPrize = prizes[i];
          commit({ type: 'setMonthlyPrize', value: monthlyPrize });
        } else if (prizes[i].type === state.prizes.GRAND) {
          const grandPrize = prizes[i];
          commit({ type: 'setGrandPrize', value: grandPrize});
        }
      }
      /* eslint-enable */
      commit('setAvailablePrizeTypes', types);
    }).catch((error) => {
      console.log(`Invoking storeAvailablePrizetypes failed with the following error: ${error}`);
    });
  },
  storePrizesAndWinners({ commit }, payload) {
    return axios({
      url: 'api/getPrizeLeaderboardDetails',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        language: payload.language,
        prizeType: payload.prizeType,
      },
    }).then((response) => {
      const responseData = response.data.data;
      // eslint-disable-next-line
      console.log(responseData);
      if (responseData !== undefined) {
        const prizes = [];
        const winners = [];
        const ranks = [];
        Object.keys(responseData).forEach((key) => {
          if (responseData && Object.prototype.hasOwnProperty.call(responseData, key)) {
            prizes.push({
              activeFrom: (responseData[key]) ? responseData[key].activeFrom : '',
              activeTo: (responseData[key]) ? responseData[key].activeTo : '',
              banner: (responseData[key]) ? responseData[key].banner : '',
              description: (responseData[key]) ? responseData[key].description : '',
              eligibilityCriteria: (responseData[key]) ? responseData[key].eligibilityCriteria : '',
              headline: (responseData[key]) ? responseData[key].headline : '',
              imgUrl: (responseData[key]) ? responseData[key].imgUrl : '',
              type: (responseData[key]) ? responseData[key].type : '',
              lastRefreshed: (responseData[key]) ? responseData[key].lastRefreshed : '',
            });
            winners.push((responseData[key]) ? responseData[key].userRankPointsDTOList : []);
            commit('users/setSearchedUsers', winners.flatMap(w => w), { root: true });
            ranks.push((responseData[key]) ? responseData[key].rankDTO : []);
          }
        });
        if (payload.prizeType === 'DAILY') {
          commit('setDailyPrizeForLeaderboard', prizes);
          commit('setDailyWinnersForLeaderboard', winners);
          commit('setDailyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'WEEKLY') {
          commit('setWeeklyPrizeForLeaderboard', prizes);
          commit('setWeeklyWinnersForLeaderboard', winners);
          commit('setWeeklyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'MONTHLY') {
          commit('setMonthlyPrizeForLeaderboard', prizes);
          commit('setMonthlyWinnersForLeaderboard', winners);
          commit('setMonthlyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'GRAND') {
          commit('setGrandPrizeForLeaderboard', prizes);
          commit('setGrandWinnersForLeaderboard', winners);
          commit('setGrandRankForLeaderboard', ranks);
        }
      }
    }).catch((error) => {
      console.log(`Invoking storePrizeAndWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  resetPassword({ commit, state }, payload) {
    console.log('resetPassword process: ');
    return axios({
      url: 'api/resetUserPassword',
      method: 'POST',
      data: {
        msisdn: payload.msisdn,
        passwordOld: state.hashedPass,
        password: payload.password,
      },
    }).then((response) => {
      console.log(response);
      commit('setHashedPassForForgotPass', null);
    }).catch((error) => {
      console.log(`Invoking resetPassword failed with the following error: ${error}`);
    });
  },
  storeVisitorWinners({ commit, state }, userLanguage) {
    return axios.get(`api/getWinnersData?lang=${userLanguage}`).then((response) => {
      const winners = response.data.data;
      commit({ type: 'setWinners', value: winners });
      const extraArrays = [];
      // deep clone because the object in splice function deletes the attributes from the same memory pool
      for (let i = 0; i < state.visitorWinners.length; i += 1) {
        extraArrays.push(state.visitorWinners[i]);
      }
      if (extraArrays.length > state.numberOfDefaultDisplayWinners) {
        commit('setMoreWinnersButton', true);
        for (let k = state.numberOfDefaultDisplayWinners; k < extraArrays.length; k += 1) {
          extraArrays.splice(k);
        }
      }
      commit({ type: 'setExtraWinners', value: extraArrays });
    }).catch((error) => {
      console.log(`Invoking storeBalanceVisitorWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  checkCoreResponses({ commit }) {
    // eslint-disable-next-line
    if (auth.getJwt()) {
      console.log('checkCoreResponses in common');
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum !== 'OPERATION_SUCCESS') {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
          // eslint-disable-next-line
          console.log('Core is down');
          return 'CORE_IS_DOWN';
        } return null;
      }).catch((error) => {
        console.log(`Invoking checkCoreResponses failed with the following error: ${error}`);
      });
    }
  },
  // eslint-disable-next-line
  getUserLoginDetails({ commit, state }) {
    console.log('getUserLoginDetails call');
    if (auth.getJwt()) {
      console.log('getUserLoginDetails call with correct jwt');
      commit('setjwtFromStorage', auth.getJwt());
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
        // eslint-disable-next-line
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          // themes
          commit('storeThemes', response.data.data.themeDTOS);
          // history
          commit({ type: 'storeGameHistoryData', value: response.data.data.userGameHistoryDTO });
          if (state.gameHistoryData.length !== 0) {
            console.log('GAMEHISTORY TRUE');
            commit('setShowHistory', true);
          } else {
            console.log('GAMEHISTORY FALSE');
            commit('setShowHistory', false);
          }
          // userDetails
          const userDetails = response.data.data.userDTO;
          console.log('inside userDetails:', userDetails);
          commit('common/storeUserDetails', userDetails, { root: true });
          console.log('getUserDetails process from DB');
          return axios({
            url: 'api/userDetails',
            method: 'GET',
            headers: {
              Authorization: auth.getJwt(),
            },
            // eslint-disable-next-line
          }).then((responseUserDetails) => {
            if (responseUserDetails.data.responseEnum === 'OPERATION_SUCCESS') {
              const userDetails = responseUserDetails.data.data;
              // eslint-disable-next-line
              console.log('-------------userDetails From userDetails---------------------------: ' + userDetails.displayAvatar);
              commit('common/storeUserDetailsFromDuel', userDetails, { root: true });
              console.log('TRUE in common');
              return axios({
                url: 'publicapi/getMultiOperatorConfigProperties',
                method: 'GET',
                params: {
                  operatorKey: userDetails.operator || '',
                },
              }).then((response) => {
                commit('common/updateServicePromotion', { value: response.data.data.enablePopUpForCrossPromotion }, { root: true });
                commit('common/updateOptOutFromHome', { value: response.data.data.showOptOutPhase }, { root: true });
                commit('common/setReoptinOptoutConfig', { value: response.data.data.reoptinAndOptoutConfig }, { root: true });
                commit('common/updateSubAndUnsubViaSMS', { value: response.data.data.subAndUnsubViaSMS }, { root: true });
                commit('common/updateMultiOperatorOrdinal', { value: response.data.data.multiOperatorOrdinal }, { root: true });
                commit('common/setHideStore', { value: response.data.data.hideStore }, { root: true });
                commit('common/setSmsAutomaticResponse', { value: response.data.data.smsAutomaticResponse }, { root: true });
                commit('common/setDisplayPrice', { value: response.data.data.displayPrice }, { root: true });
                commit('common/updatePinForBundles', { value: response.data.data.pinForBundles }, { root: true });
                commit('common/storePurchaseViaSMS', { value: response.data.data.purchaseViaSMS }, { root: true });
              }).catch((error) => {
                console.log(`Invoking publicapi/getMultiOperatorConfigProperties failed with the following error: ${error}`);
              });
              // sessionStorage.setItem('visitorCurrentTabPath', '/home');
            }
          }).catch((error) => {
            console.log(`Invoking userDetails failed with the following error: ${error}`);
          });
          // eslint-disable-next-line
        } else {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
        }
      }).catch((error) => {
        console.log(`Invoking getUserLoginDetails failed with the following error: ${error}`);
      });
    }
  },
  storeLoginInfo({ commit }, payload) {
    if (payload.rememberMeParameter) {
      localStorage.setItem('jwtToken', payload.token);
      localStorage.setItem('username', payload.username);
      commit({ type: 'setjwtFromStorage', jwt: localStorage.getItem('jwtToken') });
    } else {
      sessionStorage.setItem('username', payload.username);
      sessionStorage.setItem('jwtToken', payload.token);
      commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
    }
    commit('setUserAuthorized', true);
  },
  callForAuthorizationFB({ commit }, payload) {
    // eslint-disable-next-line
    console.log('Authorization Process with FB TOKEN');
    return axios({
      url: '/authFb',
      method: 'POST',
      data: {
        accessToken: payload.accessToken,
        msisdn: payload.msisdn,
      },
    }).then((response) => {
      // get body data
      const TokenObject = response.data;
      const tokenExists = true;
      if (tokenExists) {
        return axios({
          url: '/user',
          method: 'GET',
          headers: {
            Authorization: TokenObject.token,
          },
        }).then((responseUser) => {
          // get body data
          console.log(`Invoking user via FB with the following username: ${responseUser.data.username}`);
          // if (payload.rememberMe) {
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit({ type: 'setjwtFromStorage', jwt: localStorage.getItem('jwtToken') });
          commit('setUserAuthorized', true);
        }, (responseUser) => {
          // error callback
          console.log(responseUser);
          commit('setUserAuthorized', false);
          return null;
        });
      }
      return null;
    }, (response) => {
      // error callback
      console.log(response);
      console.log('error callback');
      commit('setUserAuthorized', false);
      return null;
    });
  },
  callForAuthorization({ commit }, payload) {
    // eslint-disable-next-line
    const { username, password, operator, rememberMe, correlationId, clickId, refUrl, campaignId, prize, freePlayPoints, publisherId, inviteReferral, fbReferral } = payload;
    console.log('AUTHORIZATION Process');
    return axios.post('/auth', {
      username,
      password,
      operator,
      rememberMe,
      correlationId,
      clickId,
      refUrl,
      prize,
      freePlayPoints,
      campaignId,
      publisherId,
      inviteReferral,
      fbReferral,
    }).then((response) => {
      // get body data
      // console.log(`Invoking /callForAuthorization failed with the following error: ${response}`);
      if (response.data === 'MSISDN_INVALID' || response.data === 'PIN_EXPIRED' || response.data === 'WRONG_PIN') {
        // SIMPLE_WITH_WEB_REGISTRATION cases
        sessionStorage.setItem('operatorError', 'false');
        return response.data;
      } else if (response.data === 'MSISDN_NOT_EXIST') {
        sessionStorage.setItem('operatorError', 'true');
        return response.data;
      }
      sessionStorage.setItem('operatorError', 'false');
      const TokenObject = response.data;
      return axios({
        url: '/user',
        method: 'GET',
        headers: {
          Authorization: TokenObject.token,
        },
      }).then((responseUser) => {
        // get body data
        console.log(`Invoking user with the following username: ${responseUser.data.username}`);
        if (payload.rememberMe) {
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit('setjwtFromStorage', localStorage.getItem('jwtToken'));
        } else {
          sessionStorage.setItem('username', responseUser.data.username);
          sessionStorage.setItem('jwtToken', TokenObject.token);
          commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
        }
        commit('setUserAuthorized', true);
      }).catch((error) => {
        commit('setUserAuthorized', false);
        console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
      });
    }).catch((error) => {
      commit('setUserAuthorized', false);
      console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js